import { cx } from '@linaria/core';
import { flex } from 'styles/utils';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { creditBalanceShimmer, shimmerPlaceholder } from './common.styles';
import { useCreditBalance } from '../hooks/useCreditBalance';
import { getCreditBalanceColorClass } from './utils';

interface CreditInfoProps {
  text: string;
}

export const CreditBalance: React.FC<CreditInfoProps> = ({ text }) => {
  const { creditBalance, creditBalanceRaw, isLoadingBalance } = useCreditBalance({ disableCreditGrantFetch: true });
  const { creditsConfig } = useFeatureFlagsLD();

  const colorClass = getCreditBalanceColorClass(creditBalanceRaw, creditsConfig?.minCredit, creditsConfig?.recommendedCredit);

  return (
    <span className={cx(flex.init, flex.alignItems.center, flex.gap.quarter)}>
      {text}{' '}
      {isLoadingBalance ? (
        <span className={cx(shimmerPlaceholder, creditBalanceShimmer)} aria-label="Loading credit balance" />
      ) : (
        <strong className={colorClass}>${creditBalance?.toFixed(2)}</strong>
      )}
    </span>
  );
};
